import { api } from './../../system/api';

export default {
    suggest: () => api.get('/official-forms/suggest')
};
